import { render, staticRenderFns } from "./BindTeacher.vue?vue&type=template&id=5aa557d2&scoped=true"
import script from "./BindTeacher.vue?vue&type=script&lang=js"
export * from "./BindTeacher.vue?vue&type=script&lang=js"
import style0 from "./BindTeacher.vue?vue&type=style&index=0&id=5aa557d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa557d2",
  null
  
)

export default component.exports